import { render, staticRenderFns } from "./MerchantIdList.vue?vue&type=template&id=11857152&scoped=true"
import script from "./MerchantIdList.vue?vue&type=script&lang=js"
export * from "./MerchantIdList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11857152",
  null
  
)

export default component.exports